import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { SLOT_DURATION } from 'ziphy-web-shared/basic/entities/schedules';
import { useDateNow } from 'ziphy-web-shared/basic/hooks';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import { HOUR_HEIGHT } from '../../../Calendar.constants';
import { $calendar } from '../../../Calendar.store';
import styles from './Timeline.module.scss';
const Timeline = ({ show = true, startIndex, endIndex, topPadding = 0 }) => {
    const today = moment.tz($calendar.timezone).startOf('day');
    const start = today.clone().add(startIndex * SLOT_DURATION, 'minutes');
    const end = today.clone().add(endIndex * SLOT_DURATION, 'minutes');
    const now = useDateNow($calendar.timezone).clone().startOf('minute');
    const outOfDay = now.isSameOrBefore(start) && now.isSameOrAfter(end);
    const top = topPadding + (HOUR_HEIGHT / 60) * now.diff(start, 'minutes');
    return (_jsx("div", Object.assign({ id: "schedule-timeline", className: classNames(styles.timeline, (!show || outOfDay) && styles.invisible), style: { top } }, { children: _jsx("span", Object.assign({ className: styles.value }, { children: formatDate(now, { format: 'time', timezone: $calendar.timezone }) })) })));
};
export default observer(Timeline);
